/* V·lette Size Fit Guarantee V1 — delegated events + independent dialog. */
(function () {
  'use strict';
  if (window.__vletteFitGuaranteeInitialized) return;
  window.__vletteFitGuaranteeInitialized = true;

  var activeSheet = null;
  var activeTrigger = null;
  var hideTimer = null;
  var closingSheet = null;
  var token = 0;

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function panelOf(sheet) {
    return sheet ? sheet.querySelector('.vlette-fit-sheet__panel') : null;
  }

  function getSheet(trigger) {
    var id = trigger && trigger.getAttribute('aria-controls');
    var node = id && document.getElementById(id);
    return node && node.matches('[data-vlette-fit-sheet]') ? node : null;
  }

  function openSheet(sheet, trigger) {
    if (!sheet || !trigger) return;
    if (activeSheet && activeSheet !== sheet) closeSheet(activeSheet, false, true);

    window.clearTimeout(hideTimer);
    hideTimer = null;
    closingSheet = null;
    token += 1;
    var openingToken = token;

    // Product grids and sticky elements can trap fixed overlays. Move to body
    // only when the user opens the sheet; keep all product markup untouched.
    if (sheet.parentNode !== document.body) document.body.appendChild(sheet);

    if (activeTrigger && activeTrigger !== trigger) activeTrigger.setAttribute('aria-expanded', 'false');
    activeSheet = sheet;
    activeTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    var panel = panelOf(sheet);
    if (panel) panel.scrollTop = 0;
    document.documentElement.classList.add('vlette-fit-is-open');

    window.requestAnimationFrame(function () {
      if (token !== openingToken || activeSheet !== sheet) return;
      sheet.classList.add('is-visible');
      if (panel) panel.focus({preventScroll: true});
    });
  }

  function closeSheet(sheet, restoreFocus, immediate) {
    sheet = sheet || activeSheet;
    if (!sheet || sheet.hidden) return;
    window.clearTimeout(hideTimer);
    hideTimer = null;
    token += 1;
    closingSheet = sheet;
    sheet.classList.remove('is-visible');
    sheet.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vlette-fit-is-open');

    var trigger = activeTrigger;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (activeSheet === sheet) {
      activeSheet = null;
      activeTrigger = null;
    }
    if (restoreFocus !== false && trigger && document.contains(trigger)) {
      trigger.focus({preventScroll: true});
    }

    function finish() {
      if (closingSheet === sheet && activeSheet !== sheet) {
        sheet.hidden = true;
        closingSheet = null;
      }
      hideTimer = null;
    }

    if (immediate || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      finish();
    } else {
      hideTimer = window.setTimeout(finish, 260);
    }
  }

  function trapFocus(event) {
    if (!activeSheet || activeSheet.hidden || event.key !== 'Tab') return;
    var panel = panelOf(activeSheet);
    if (!panel) return;
    var candidates = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var focusable = Array.prototype.filter.call(candidates, function (item) {
      return !item.hidden && item.getAttribute('aria-hidden') !== 'true' && item.getClientRects().length > 0;
    });
    if (!focusable.length) { event.preventDefault(); panel.focus(); return; }
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel || !activeSheet.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = closest(event.target, '[data-vlette-fit-open]');
    if (trigger) {
      var sheet = getSheet(trigger);
      if (!sheet) return; // Still allow anchor fallback if Shopify hasn't rendered sheet.
      event.preventDefault();
      event.stopPropagation();
      openSheet(sheet, trigger);
      return;
    }
    var close = closest(event.target, '[data-vlette-fit-close]');
    if (close && activeSheet && closest(close, '[data-vlette-fit-sheet]') === activeSheet) {
      event.preventDefault();
      event.stopPropagation();
      closeSheet(activeSheet, true, false);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!activeSheet || activeSheet.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeSheet(activeSheet, true, false); }
    else trapFocus(event);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var id = event.detail && event.detail.sectionId;
    if (!id) return;
    var sheets = document.querySelectorAll('[data-vlette-fit-sheet][data-vlette-fit-section-id]');
    for (var i = 0; i < sheets.length; i++) {
      var sheet = sheets[i];
      if (sheet.getAttribute('data-vlette-fit-section-id') !== String(id)) continue;
      if (sheet === activeSheet) closeSheet(sheet, false, true);
      if (sheet.parentNode === document.body) sheet.remove();
    }
  });
})();
